// Samara Smile — scripts propios (vanilla, sin librerias externas)
document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initCountUp();
  initGallery();
  initVariantPicker();
  initQtyStepper();
  initStickyBar();
  initVitrinaCarrusel();
  initResenasCarrusel();
  initWhatsappPixel();
  initPackSelector();
  initUgccCarrusel();
  initVideoOverlay();
  initCapturasCarrusel();
  initCodWhatsapp();
});

function initCodWhatsapp() {
  var dialog = document.querySelector('[data-ss-cod]');
  var openBtn = document.querySelector('[data-ss-cod-open]');
  if (!dialog || !openBtn || typeof dialog.showModal !== 'function') return;

  var form = dialog.querySelector('[data-ss-cod-form]');
  var errorEl = dialog.querySelector('[data-ss-cod-error]');
  var listoEl = dialog.querySelector('[data-ss-cod-listo]');
  var linkEl = dialog.querySelector('[data-ss-cod-link]');
  var variants = [];
  try { variants = JSON.parse(dialog.querySelector('[data-ss-cod-variants]').textContent); } catch (e) {}
  if (!variants.length) return;

  var phone = dialog.getAttribute('data-phone');
  var producto = dialog.getAttribute('data-producto');
  var promo2x1 = dialog.getAttribute('data-2x1') === 'true';
  var umbral = (parseFloat(dialog.getAttribute('data-umbral')) || 0) * 100;
  var costoEnvio = (parseFloat(dialog.getAttribute('data-costo-envio')) || 0) * 100;

  function pesos(cents) {
    return '$' + Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function pedidoActual() {
    var idInput = document.querySelector('[data-ss-variant-id]');
    var qtyInput = document.querySelector('[data-ss-qty-input]');
    var id = idInput ? parseInt(idInput.value, 10) : null;
    var variant = variants.find(function (v) { return v.id === id; }) || variants[0];
    var qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
    // 2x1: de cada 2 unidades se paga 1 (igual que el descuento automático del carrito)
    var pagas = promo2x1 ? qty - Math.floor(qty / 2) : qty;
    var subtotal = variant.price * pagas;
    var envio = subtotal >= umbral ? 0 : costoEnvio;
    var nombre = producto + (variant.title && variant.title !== 'Default Title' ? ' (' + variant.title + ')' : '');
    return { variant: variant, qty: qty, nombre: nombre, subtotal: subtotal, envio: envio, total: subtotal + envio };
  }

  function pintarResumen() {
    var p = pedidoActual();
    dialog.querySelector('[data-ss-cod-linea]').textContent = p.qty + ' × ' + p.nombre;
    dialog.querySelector('[data-ss-cod-subtotal]').textContent = pesos(p.subtotal);
    dialog.querySelector('[data-ss-cod-envio]').textContent = p.envio === 0 ? 'Gratis' : pesos(p.envio);
    dialog.querySelector('[data-ss-cod-total]').textContent = pesos(p.total);
  }

  openBtn.addEventListener('click', function () {
    errorEl.hidden = true;
    listoEl.hidden = true;
    pintarResumen();
    dialog.showModal();
  });
  dialog.querySelector('[data-ss-cod-close]').addEventListener('click', function () { dialog.close(); });
  dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var p = pedidoActual();
    var datos = {};
    var faltan = [];
    form.querySelectorAll('input, select').forEach(function (el) {
      datos[el.name] = el.value.trim();
      var invalido = el.required && !datos[el.name];
      if (el.name === 'celular' && datos.celular && datos.celular.replace(/\D/g, '').length < 8) invalido = true;
      el.classList.toggle('ss-cod-invalido', invalido);
      if (invalido) faltan.push(el);
    });

    if (!p.variant.available) {
      errorEl.textContent = 'Este producto está agotado por el momento.';
      errorEl.hidden = false;
      return;
    }
    if (faltan.length) {
      errorEl.textContent = 'Completá los campos marcados para confirmar tu pedido.';
      errorEl.hidden = false;
      faltan[0].focus();
      return;
    }
    errorEl.hidden = true;

    var lineas = [
      '🛒 *NUEVO PEDIDO — PAGO CONTRA ENTREGA*',
      '',
      '📦 *Producto:* ' + p.nombre,
      '🔢 *Cantidad:* ' + p.qty + (promo2x1 && p.qty >= 2 ? ' (promo 2x1 aplicada)' : ''),
      '💲 *Subtotal:* ' + pesos(p.subtotal),
      '🚚 *Envío:* ' + (p.envio === 0 ? 'Gratis' : pesos(p.envio)),
      '💵 *Total a pagar al recibir:* ' + pesos(p.total),
      '',
      '👤 *Nombre:* ' + datos.nombre,
      '📱 *Celular:* ' + datos.celular,
      '📍 *Departamento:* ' + datos.departamento,
      '🏙️ *Ciudad/Barrio:* ' + datos.ciudad,
      '🏠 *Dirección:* ' + datos.direccion
    ];
    if (datos.nota) lineas.push('📝 *Referencia:* ' + datos.nota);
    lineas.push('', 'Quedo a la espera de la confirmación. ¡Gracias!');

    var url = 'https://wa.me/' + phone + '?text=' + encodeURIComponent(lineas.join('\n'));

    if (typeof fbq === 'function') {
      fbq('track', 'Lead', { value: p.total / 100, currency: 'UYU', content_name: p.nombre, content_ids: [String(p.variant.id)], num_items: p.qty });
    }

    linkEl.href = url;
    listoEl.hidden = false;
    // En celular abre la app de WhatsApp; en computadora usa otra pestaña para no perder la tienda.
    if (window.matchMedia('(pointer: coarse)').matches) {
      window.location.href = url;
    } else {
      window.open(url, '_blank', 'noopener');
    }
  });
}

function initCapturasCarrusel() {
  document.querySelectorAll('[data-ss-capturas-track]').forEach(function (track) {
    var wrap = track.closest('.ss-section');
    if (!wrap) return;
    var prev = wrap.querySelector('[data-ss-capturas-prev]');
    var next = wrap.querySelector('[data-ss-capturas-next]');
    var scrollAmount = function () {
      var card = track.querySelector('.ss-captura-card');
      return card ? card.getBoundingClientRect().width + 18 : 268;
    };
    prev && prev.addEventListener('click', function () {
      track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
    });
    next && next.addEventListener('click', function () {
      track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
    });
  });
}

function initVideoOverlay() {
  document.querySelectorAll('[data-ss-video-wrap]').forEach(function (wrap) {
    var video = wrap.querySelector('video');
    var overlay = wrap.querySelector('[data-ss-video-play]');
    if (!video || !overlay) return;
    overlay.addEventListener('click', function () {
      wrap.classList.add('ss-video-playing');
      video.play();
    });
    video.addEventListener('play', function () {
      wrap.classList.add('ss-video-playing');
    });
  });
}

function initUgccCarrusel() {
  document.querySelectorAll('[data-ss-ugcc-track]').forEach(function (track) {
    var wrap = track.closest('.ss-section');
    if (!wrap) return;
    var prev = wrap.querySelector('[data-ss-ugcc-prev]');
    var next = wrap.querySelector('[data-ss-ugcc-next]');
    var scrollAmount = function () {
      var card = track.querySelector('.ss-ugcc-card');
      return card ? card.getBoundingClientRect().width + 20 : 260;
    };
    prev && prev.addEventListener('click', function () {
      track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
    });
    next && next.addEventListener('click', function () {
      track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
    });
  });
}

function initPackSelector() {
  var wrap = document.querySelector('[data-ss-packs]');
  if (!wrap) return;
  var qtyInput = document.querySelector('[data-ss-qty-input]');
  var cards = wrap.querySelectorAll('[data-ss-pack]');
  if (!cards.length) return;

  function selectCard(card) {
    cards.forEach(function (c) { c.classList.remove('ss-pack-active'); });
    card.classList.add('ss-pack-active');
    if (qtyInput) {
      qtyInput.value = card.getAttribute('data-qty') || '1';
      qtyInput.dispatchEvent(new Event('change'));
    }
  }

  cards.forEach(function (card) {
    card.addEventListener('click', function () { selectCard(card); });
  });

  var preselected = wrap.querySelector('.ss-pack-active');
  if (preselected && qtyInput) {
    qtyInput.value = preselected.getAttribute('data-qty') || '1';
  }

  if (qtyInput) {
    qtyInput.addEventListener('change', function () {
      var match = wrap.querySelector('[data-ss-pack][data-qty="' + qtyInput.value + '"]');
      cards.forEach(function (c) { c.classList.remove('ss-pack-active'); });
      if (match) match.classList.add('ss-pack-active');
    });
  }
}

function initReveal() {
  var els = document.querySelectorAll('.ss-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('ss-visible'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('ss-visible');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.05, rootMargin: '0px 0px 10% 0px' });
  els.forEach(function (el) { io.observe(el); });
}

function initCountUp() {
  var els = document.querySelectorAll('.ss-countup');
  if (!els.length) return;
  var run = function (el) {
    var target = parseFloat(el.getAttribute('data-target') || '0');
    var suffix = el.getAttribute('data-suffix') || '';
    var dur = 1400;
    var start = null;
    el.textContent = '0' + suffix;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      var val = Math.round(target * eased);
      el.textContent = val + suffix;
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  };
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) {
      el.textContent = (el.getAttribute('data-target') || '0') + (el.getAttribute('data-suffix') || '');
    });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        run(entry.target);
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.4 });
  els.forEach(function (el) { io.observe(el); });
}

function initGallery() {
  var galleries = document.querySelectorAll('[data-ss-gallery]');
  galleries.forEach(function (gallery) {
    var main = gallery.querySelector('[data-ss-gallery-main]');
    var thumbs = gallery.querySelectorAll('[data-ss-gallery-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        if (!full) return;
        main.style.opacity = '0';
        setTimeout(function () {
          // La foto principal usa srcset (tamaño según pantalla): se cambia junto con src
          var srcset = thumb.getAttribute('data-srcset');
          if (srcset) main.srcset = srcset; else main.removeAttribute('srcset');
          main.src = full;
          main.style.opacity = '1';
        }, 150);
        thumbs.forEach(function (t) { t.classList.remove('ss-thumb-active'); });
        thumb.classList.add('ss-thumb-active');
      });
    });
  });
}

function initVariantPicker() {
  var forms = document.querySelectorAll('[data-ss-product-form]');
  forms.forEach(function (formWrap) {
    var dataEl = formWrap.querySelector('[data-ss-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var selects = formWrap.querySelectorAll('[data-ss-option]');
    var idInput = formWrap.querySelector('[data-ss-variant-id]');
    var priceEl = formWrap.querySelector('[data-ss-price]');
    var compareEl = formWrap.querySelector('[data-ss-compare-price]');
    var submitBtn = formWrap.querySelector('[data-ss-submit]');
    if (!selects.length || !idInput) return;

    function currentSelection() {
      var sel = [];
      selects.forEach(function (s) { sel.push(s.value); });
      return sel;
    }
    function findVariant(sel) {
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === sel[i]; });
      });
    }
    var currency = formWrap.getAttribute('data-currency') || '';
    function formatMoney(cents) {
      // Mismo formato que money_without_trailing_zeros: $1.685 UYU (decimales solo si los hay)
      var partes = (cents / 100).toFixed(2).split('.');
      var amount = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + (partes[1] === '00' ? '' : ',' + partes[1]);
      return '$' + amount + (currency ? ' ' + currency : '');
    }
    function update() {
      var sel = currentSelection();
      var variant = findVariant(sel);
      if (!variant) return;
      idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (submitBtn) {
        // Solo se cambia el texto interno para no borrar el icono del candado
        var etiqueta = submitBtn.querySelector('[data-ss-submit-text]') || submitBtn;
        if (variant.available) {
          submitBtn.disabled = false;
          etiqueta.textContent = submitBtn.getAttribute('data-label-add') || etiqueta.textContent;
        } else {
          submitBtn.disabled = true;
          etiqueta.textContent = submitBtn.getAttribute('data-label-sold-out') || 'Agotado';
        }
      }
    }
    selects.forEach(function (s) { s.addEventListener('change', update); });
  });
}

function initQtyStepper() {
  var steppers = document.querySelectorAll('.ss-qty-stepper');
  steppers.forEach(function (stepper) {
    var input = stepper.querySelector('[data-ss-qty-input]');
    var minus = stepper.querySelector('[data-ss-qty-minus]');
    var plus = stepper.querySelector('[data-ss-qty-plus]');
    if (!input) return;
    minus && minus.addEventListener('click', function () {
      var v = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      input.value = v;
    });
    plus && plus.addEventListener('click', function () {
      var v = (parseInt(input.value, 10) || 1) + 1;
      input.value = v;
    });
    input.addEventListener('change', function () {
      var v = parseInt(input.value, 10);
      if (!v || v < 1) input.value = 1;
    });
  });
}

function initStickyBar() {
  var bar = document.querySelector('[data-ss-sticky-bar]');
  var mainForm = document.querySelector('[data-ss-product-form] form');
  var mainAddBtn = document.querySelector('[data-ss-submit]');
  if (!bar || !mainForm) return;

  var stickyBtn = bar.querySelector('[data-ss-sticky-submit]');
  if (stickyBtn) {
    stickyBtn.addEventListener('click', function () {
      if (mainForm.requestSubmit) mainForm.requestSubmit();
      else mainForm.submit();
    });
  }

  var trigger = document.querySelector('.ss-producto-add');
  if (!trigger) return;

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      bar.classList.toggle('ss-sticky-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
    });
  }, { threshold: 0 });
  io.observe(trigger);

  if (mainAddBtn && stickyBtn) {
    var syncState = function () {
      stickyBtn.disabled = mainAddBtn.disabled;
      var fuente = mainAddBtn.querySelector('[data-ss-submit-text]') || mainAddBtn;
      stickyBtn.textContent = fuente.textContent.trim();
    };
    syncState();
    var mo = new MutationObserver(syncState);
    mo.observe(mainAddBtn, { attributes: true, childList: true, characterData: true, subtree: true });
  }
}

function initVitrinaCarrusel() {
  document.querySelectorAll('[data-ss-vitrina-track]').forEach(function (track) {
    var wrap = track.closest('.ss-section');
    if (!wrap) return;
    var prev = wrap.querySelector('[data-ss-vitrina-prev]');
    var next = wrap.querySelector('[data-ss-vitrina-next]');
    var scrollAmount = function () {
      var card = track.querySelector('.ss-vitrina-card');
      return card ? card.getBoundingClientRect().width + 20 : 280;
    };
    prev && prev.addEventListener('click', function () {
      track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
    });
    next && next.addEventListener('click', function () {
      track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
    });
  });
}

function initResenasCarrusel() {
  document.querySelectorAll('[data-ss-resenas-track]').forEach(function (track) {
    var wrap = track.closest('.ss-section');
    if (!wrap) return;
    var prev = wrap.querySelector('[data-ss-resenas-prev]');
    var next = wrap.querySelector('[data-ss-resenas-next]');
    var scrollAmount = function () {
      var card = track.querySelector('.ss-resena-card');
      return card ? card.getBoundingClientRect().width + 24 : 320;
    };
    prev && prev.addEventListener('click', function () {
      track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
    });
    next && next.addEventListener('click', function () {
      track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
    });
  });
}

function initWhatsappPixel() {
  var links = document.querySelectorAll('a[href*="wa.me"]');
  links.forEach(function (link) {
    link.addEventListener('click', function () {
      if (typeof fbq === 'function') {
        fbq('track', 'Contact');
      }
    });
  });
}
